import { FormState } from '@vtex/admin-ui-form'
import { useCallback } from 'react'

export interface SettingsProps {
  state: FormState
}

type useGenericComponentType<T extends string, Props extends {}> = {
  settings: Record<T, (props: Props) => JSX.Element | null>
  type: T | undefined
}

export function useGenericComponent<T extends string, Props extends {}>(
  props: useGenericComponentType<T, Props>
) {
  const { settings, type } = props

  const GenericComponent = useCallback(
    (props: Props) => {
      if (!type) return null

      const Component = settings[type]

      if (!Component) return null

      return <Component {...(props as any)} />
    },
    [settings, type]
  )

  return {
    GenericComponent,
  }
}
